import {
    IonText,
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail,
    IonRippleEffect
} from '@ionic/react';
import { chevronForwardOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';
import '../pages/Main.css'; 

import TitleContent from '../components/TitleContent';
import AddMyContent from '../components/AddMyContent';
import ContentView from '../components/ContentView';
import VideoContent from '../components/VideoContent';
import VidFileContent from '../components/VidFileContent';
import UserTitleContent from '../components/UserTitleContent';
import MeTitleContent from '../components/MeTitleContent';
import SearchBarContent from '../components/SearchBarContent';
import TextContent from '../components/TextContent';
import ImageContent from '../components/ImageContent';
import NoMoreContent from '../components/NoMoreContent';
import EmptyContent from '../components/EmptyContent';
import CategoriesContent from '../components/CategoriesContent';
import ExploreEmptyContent from '../components/ExploreEmptyContent';
import LiveChatContent from '../components/LiveChatContent';
import ReelContent from '../components/ReelContent';
import MarketItem from '../components/MarketItem';
import EmptyMarketContent from '../components/EmptyMarketContent';
  
const ContentWrapper : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    return (
        <div className="content-wrapper">
            {
                content.type == "title" ?
            <TitleContent content={content} />
                :
                content.type == "nomore" ?
            <NoMoreContent nomore={true} />
                :
                content.type == "addmy" ?
            <AddMyContent content={content} />
                :
                content.type == "categories" ?
            <CategoriesContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "video" ?
            <VideoContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "text" ?
            <TextContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "image" ?
            <ImageContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "vidfile" ?
            <VidFileContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "reel" ?
            <ReelContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "user" ?
            <UserTitleContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "livechat" ?
            <LiveChatContent content={content} />
                :
                content.type == "me" ?
            <MeTitleContent content={content} />
                :
                content.type == "searchbar" ?
            <SearchBarContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "market" ?
            <MarketItem content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "empty_content" ?
            <EmptyContent content={content} />
                :
                content.type == "market_empty" ?
            <EmptyMarketContent content={content} />
                :
                content.type == "explore_empty" ?
            <ExploreEmptyContent content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
                content.type == "empty" || content.type == "blocked" ?
            <div className="empty-content"/>
                :
            <ContentView content={content} />
            }
        </div>
    );
};
  
export default ContentWrapper;